import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-44-luca-fontanelli-guest.webp";
import ThumbImg from "../../assets/images/conversations/044.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: lf-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .lf-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .lf-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .lf-hero { padding-top: 60px; padding-bottom: 60px; }
  .lf-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .lf-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .lf-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .lf-hero__title.lf-visible { opacity: 1; transform: translateY(0); }
  .lf-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .lf-hero__spotify.lf-visible { opacity: 1; transform: translateY(0); }
  .lf-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .lf-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .lf-hero__right.lf-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .lf-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .lf-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .lf-yt-thumb:hover img { opacity: 0.85; }
  .lf-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .lf-yt-thumb__play img { width: 40px; height: 44px; }
  .lf-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .lf-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .lf-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .lf-body.lf-visible { opacity: 1; transform: translateY(0); }
  .lf-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .lf-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .lf-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .lf-guest.lf-visible { opacity: 1; transform: translateY(0); }
  .lf-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .lf-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .lf-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .lf-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .lf-inner { padding-left: 32px; padding-right: 32px; }
    .lf-hero { padding-top: 32px; padding-bottom: 48px; }
    .lf-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .lf-hero__title { font-size: 24px; }
    .lf-hero__left { gap: 16px; }
    .lf-guest__title { font-size: 24px; margin-bottom: 24px; }
    .lf-guest__photo-bg { width: 260px; height: 300px; }
    .lf-guest__name { font-size: 24px; margin-top: 18px; }
    .lf-body__para { font-size: 14px; margin-bottom: 12px; }
    .lf-body { padding-bottom: 48px; }
    .lf-guest { padding-bottom: 48px; }
    .lf-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .lf-inner { padding-left: 16px; padding-right: 16px; }
    .lf-hero { padding-top: 51px; padding-bottom: 30px; }
    .lf-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .lf-hero__left { gap: 30px; }
    .lf-hero__title { font-size: 30px; }
    .lf-body__para { font-size: 16px; margin-bottom: 10px; }
    .lf-guest__title { font-size: 30px; margin-bottom: 20px; }
    .lf-guest__photo-bg { width: 100%; height: 386px; }
    .lf-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .lf-body { padding-bottom: 30px; }
    .lf-guest { padding-bottom: 30px; }
    .lf-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("lf-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "4Tlo8l8GbP0";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="lf-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 44 Luca Fontanelli"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="lf-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 44 Luca Fontanelli thumbnail" />
      <div className="lf-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="lf-hero">
      <div className="lf-inner">
        <div className="lf-hero__grid">
          <div className="lf-hero__left">
            <h1 ref={titleRef} className="lf-hero__title">
              EP 44 | Decentralizing Power: Taking EV Chargers off the grid | E-GAP | Luca FONTANELLI
            </h1>
            <div ref={spotifyRef} className="lf-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0FBMmd8DTGuyOCQidcFsqu?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 44 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="lf-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="lf-body">
      <div className="lf-inner">
        <p className="lf-body__para">
          As countries around the world rapidly accelerate their transition to clean energy and clean mobility, amidst all the celebrations of zero emissions, we persistently ask a set of uncomfortable questions. What would happen if all vehicles transitioned to electric? Can the grids in different countries handle such a massive shift? And will wait times for access to charges, and then to charge, become the norm? Today, we speak to a company addressing both of these challenges. In this episode, we turn our focus to Europe as we interview the CEO of an intriguing charge point operations company that originated in Italy but now operates across Europe. Joining us is Luca Fontanelli, CEO at E-GAP.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="lf-guest">
      <div className="lf-inner">
        <h2 className="lf-guest__title">Our Guest</h2>
        <div>
          <div className="lf-guest__photo-bg">
            <img src={GuestImg} alt="Luca Fontanelli" />
          </div>
          <p className="lf-guest__name">Luca Frontanelli</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep44LucaFontanelli() {
  return (
    <>
      <style>{CSS}</style>
      <div className="lf-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}